import React, { createContext, useEffect } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Always use dark mode
  const darkMode = true;

  useEffect(() => {
    // Always set dark mode in localStorage and apply dark class
    localStorage.setItem('theme', 'dark');
    document.documentElement.classList.add('dark');
  }, []);

  // Dummy function that does nothing - keeps the interface consistent
  // but doesn't actually toggle the theme
  const toggleDarkMode = () => {
    // No-op function - we don't want to toggle the theme
    return;
  };

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      {children}
    </ThemeContext.Provider>
  );
};
